import React from "react";
import {NavLink, useNavigate, useParams} from "react-router-dom";
import * as Utils from "../../inc/Utils";
import {Config} from "../../Config";
import toast, {Toaster} from "react-hot-toast";
import MemberSidebar from "../../inc/MemberSidebar";
import "react-datepicker/dist/react-datepicker.css";

export default function BusinessFormStatusList(prop) {
    let navigate = useNavigate();
    let {encode} = useParams();
    let decode = Utils.decodeItem(encode);
    let formId = decode.id;

    let member = prop.member;

    let [statusList, setStatusList] = React.useState(null);
    let [data, setData] = React.useState(null);

    React.useEffect(() => {
        document.title = 'แบบฟอร์มคำร้องขอการรับรองคุณภาพ - NCSA';

        (async function() {
            try {
                const resultStatus = await Utils.getFormStatus();
                setStatusList(resultStatus);

                const result = await getView(formId);
                setData(result);

            } catch (e) {
                //
            }
        })();

    }, []);

    async function getView(id) {
        const response = await fetch(Config.apiUrl +'/cyberForm/viewByMember', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'x-access-token': member.accessToken
            },
            body: JSON.stringify({
                id: id
            })
        });

        if(response.ok) {
            return response.json();
        }
        else {
            return response.json().then(err => Promise.reject(err));
        }
    }

    return (
        <>
            <div className="section">
                <div className="container has-sidebar">
                    <div className="sidebar">
                        <MemberSidebar active="businessForm" lang={prop.lang} />
                    </div>
                    <div className="content">
                        <div className="card-infos has-shadow-black" data-aos="fade-in">
                            <div className="d-flex justify-content-between gap-3">
                                <h3 className="title-line-left mt-0 mb-4">{prop.lang === 'en' ? 'Business Quality Form':'แบบฟอร์มคำร้องขอการรับรองคุณภาพ'}</h3>
                                <NavLink to={'/businessForm'} className="btn btn-xs btn-gray">&larr; กลับไป</NavLink>
                            </div>

                            <div className="row g-3">
                                <div className="col-12">
                                    <div className="form-group">
                                        <h6>เลขที่คำขอ</h6>
                                        <div>{data?.code ?? '-'}</div>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="table-responsive mt-3">
                                        <table className="table table-info table-hover text-center">
                                            <thead>
                                            <tr>
                                                <th className="text-center" width="100">สถานะ</th>
                                                <th className="text-center" width="170">วันที่</th>
                                                <th className="text-start">ผู้แจ้ง</th>
                                            </tr>
                                            </thead>

                                            <tbody>
                                            {
                                                data?.cyberFormStatus.map((row, index) => {
                                                    let btnWidth = 'w-150';
                                                    let fileName = 'ไฟล์แนบ';
                                                    if(row.status === Utils.FORM_STATUS_APPROVE) {
                                                        fileName = 'เอกสารรายละเอียดการชำระเงิน';
                                                        btnWidth = 'w-220';
                                                    }
                                                    else if(row.status === Utils.FORM_STATUS_PAYMENT) {
                                                        fileName = 'หลักฐานการชำระเงิน';
                                                        btnWidth = 'w-180';
                                                    }
                                                    return (
                                                        <tr key={index} className="border-bottom">
                                                            <td className="text-center"><span className={"badge " + (Utils.formStatusColor(row.status))}>{statusList.filter(e => e.id === row.status)[0].title}</span></td>
                                                            <td className="text-center small">{Utils.dateTime(row.createdAt)}</td>
                                                            <td className="text-start">
                                                                {row.createdBy === -1 ? 'ผู้เสนอโครงการ':row.user.contact}
                                                                <p className="text-muted small mb-0">{row.detail}</p>
                                                                {
                                                                    row.status === Utils.FORM_STATUS_APPROVE ? <p className="small text-danger mb-0">ครบกำหนด {Utils.dateText(row.endDate)}</p> : ''
                                                                }

                                                                {
                                                                    row.file ? <NavLink to={Config.fileUpload + "cyber_form_status/" + row.file} target="_blank" className={"btn btn-xs btn-gray me-auto " + btnWidth}>&darr; {fileName}</NavLink> : ''
                                                                }

                                                                {
                                                                    row.file2 ? <p className="mb-0 mt-1"><NavLink to={Config.fileUpload + "cyber_form_status/" + row.file2} target="_blank" className={"btn btn-xs btn-gray me-auto " + btnWidth}>&darr; ไฟล์อื่นๆ (2)</NavLink></p> : ''
                                                                }

                                                                {
                                                                    row.file3 ? <p className="mb-0 mt-1"><NavLink to={Config.fileUpload + "cyber_form_status/" + row.file3} target="_blank" className={"btn btn-xs btn-gray me-auto " + btnWidth}>&darr; ไฟล์อื่นๆ (3)</NavLink></p> : ''
                                                                }

                                                                {
                                                                    row.file4 ? <p className="mb-0 mt-1"><NavLink to={Config.fileUpload + "cyber_form_status/" + row.file5} target="_blank" className={"btn btn-xs btn-gray me-auto " + btnWidth}>&darr; ไฟล์อื่นๆ (4)</NavLink></p> : ''
                                                                }

                                                                {
                                                                    row.file5 ? <p className="mb-0 mt-1"><NavLink to={Config.fileUpload + "cyber_form_status/" + row.file5} target="_blank" className={"btn btn-xs btn-gray me-auto " + btnWidth}>&darr; ไฟล์อื่นๆ (5)</NavLink></p> : ''
                                                                }
                                                            </td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Toaster position="top-right" />
        </>
    );
} 